import React from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function StaticPage({ kicker, title, lede, blocks = [], cta }) {
    return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <div className="max-w-[1200px] mx-auto px-4 md:px-10 pt-14 md:pt-20 pb-20">
                <div className="max-w-3xl mb-10 md:mb-14">
                    <div className="text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-platinum mb-3">
                        {kicker}
                    </div>
                    <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
                        {title}
                    </h1>
                    {lede && (
                        <p className="mt-5 text-silver-300 text-sm md:text-base leading-relaxed max-w-2xl">
                            {lede}
                        </p>
                    )}
                </div>

                <div className="grid md:grid-cols-2 gap-5 md:gap-6">
                    {blocks.map((b, i) => (
                        <div
                            key={i}
                            className="glass p-6 md:p-7 rounded-sm"
                            data-testid={`static-block-${i}`}
                        >
                            {b.eyebrow && (
                                <div className="text-[10px] tracking-[0.3em] uppercase text-platinum mb-2">
                                    {b.eyebrow}
                                </div>
                            )}
                            <h3 className="font-display text-xl md:text-2xl mb-2">
                                {b.title}
                            </h3>
                            <p className="text-silver-300 text-sm leading-relaxed">
                                {b.body}
                            </p>
                        </div>
                    ))}
                </div>

                {cta && (
                    <div className="mt-12 md:mt-16 text-center">
                        <Link
                            to={cta.href}
                            className="inline-flex items-center gap-2 bg-platinum hover:bg-platinum-200 text-ink-300 font-medium px-6 py-3 rounded-sm uppercase tracking-widest text-xs"
                        >
                            {cta.label}
                            <ChevronRight className="w-4 h-4" />
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
